/**
 * Centre d'aide : tutos hébergés par TRP, relayés par l'API du caser
 * (`monicase/aide/*`). TRP ne renvoie que les tutos ouverts à ce caser.
 */

/** Un tuto dans le sommaire. `ecran` : routes complètes du BO (`/moni/factures/:id/:action`). */
export interface AideEntree {
  slug: string;
  titre: string;
  duree: string;
  ecran: string[];
  /** Change à chaque modification du tuto (clé du cache des tutos). */
  empreinte: string;
}

export interface AideRubrique {
  cle: string;
  titre: string;
  icone: string;
  articles: AideEntree[];
}

export interface AideSommaire {
  rubriques: AideRubrique[];
  /** Change dès qu'un tuto de ce caser change. */
  version: string;
}

export interface AideArticle {
  slug: string;
  titre: string;
  duree: string;
  niveau: string | null;
  maj: string;
  ecran: string[];
  empreinte: string;
  rubrique: { cle: string; titre: string };
  /** HTML rendu par TRP (sans titre de tête), liens internes en `/aide/<slug>`. */
  html: string;
  suivant: { slug: string; titre: string }[];
}

export interface AideResultat {
  slug: string;
  titre: string;
  rubrique: string;
  extrait: string;
}

export type EtatAide = 'chargement' | 'pret' | 'indisponible';

export interface AideEnveloppe<T> {
  status: string;
  message: string;
  code: number;
  data: T;
}

/** Slug valide (même règle que l'API) : un paramètre de route n'est jamais envoyé tel quel. */
export const SLUG_AIDE = /^[a-z0-9-]+$/;
